import ValueTag from './ValueTag';
import './style/index.less';

export default ValueTag;
